<template>
    <div class="tabbar-content">
        <div class="tabbar">
            <div class="item" :class="{ 'act': actIdx == 1 }" @click.stop="change(1)">
                <span class="tabbar-icon home" :class="{ active: actIdx == 1 }"></span>
                <div class="item-text">{{ $t("tabbar.Lobby") }}</div>
            </div>
            <div class="item" :class="{ 'act': actIdx == 2 }" @click.stop="change(2)">
                <span class="tabbar-icon recharge" :class="{ active: actIdx == 2 }"></span>
                <div class="item-text">{{ $t("tabbar.Deposit") }}</div>
            </div>
            <div class="item" :class="{ 'act': actIdx == 3 }" @click.stop="change(3)">
                <span class="tabbar-icon share" :class="{ active: actIdx == 3 }"></span>
                <div class="item-text">{{ $t("tabbar.Affiliate") }}</div>
            </div>
            <!-- <div class="item center" :class="{ 'act': actIdx == 3 }" @click.stop="change(3)">
                <div class="center-img">
                    <div class="center-inset">
                        <van-image v-if="actIdx == 3" width=".6rem" height=".6rem" :show-loading="false" fit="contain"
                            :src="require('./../../assets/tabbar/shareAct.png')" />
                        <van-image v-else width=".6rem" height=".6rem" :show-loading="false" fit="contain"
                            :src="require('./../../assets/tabbar/share.png')" />
                    </div>
                </div>
                <div class="item-text">{{ $t("tabbar.Affiliate") }}</div>
            </div> -->
            <div class="item" :class="{ 'act': actIdx == 4 }" @click.stop="change(4)">
                <span class="tabbar-icon event" :class="{ active: actIdx == 4 }"></span>
                <div class="item-text">{{ $t("tabbar.Promotion") }}</div>
            </div>
            <div class="item" :class="{ 'act': actIdx == 5 }" @click.stop="change(5)">
                <span class="tabbar-icon person" :class="{ active: actIdx == 5 }"></span>
                <div class="item-text">{{ $t("tabbar.Account") }}</div>
            </div>
        </div>
        <!-- <div v-if="isShowSaveVersion" class="pwa" @click="onShowSaveVersionPopup">
            <div class="iconfont icon-jiahao"></div>
            <div class="txt">{{ $t('downApp.SaveVersionDesktop') }}</div>
            <div class="iconfont icon-s-cuowu-guanbi" @click.stop="onCloseSaveVersion"></div>
        </div> -->
        <pwaIosPopup ref="pwaIosPopup" :isToHome="false"></pwaIosPopup>
        <SaveVersionPopup ref="SaveVersionPopup" :isToHome="false"></SaveVersionPopup>
        <div style="height: 1.24rem"></div>
    </div>
</template>

<script>
import pwaIosPopup from '@/views/downAppPWA/modules/pwaIosPopup'
import SaveVersionPopup from '@/views/downAppPWA/modules/SaveVersionPopup'
import { isPWA, getPlatform } from '@/utils'
export default {
    name: 'Tabbar',
    components: { pwaIosPopup, SaveVersionPopup },
    data() {
        return {
            actIdx: 1,
            isSaveVersionDesktop: true
        }
    },
    computed: {
        isShowSaveVersion() {
            return this.$store.state.system.isSaveVersionDesktop === 1 && this.isSaveVersionDesktop && (!isPWA()) && getPlatform() !== 'android' && getPlatform() !== 'Android'
        }
    },
    created() {
        const path = this.$route.path
        if (path === '/RU') {
            this.actIdx = 1
        }
        if (path === '/Affiliate') {
            this.actIdx = 3
        }
        if (path === '/Event') {
            this.actIdx = 4
        }
        if (path === '/Person') {
            this.actIdx = 5
        }
    },
    watch: {
        $route: {
            handler: function (to, from) {
                const path = this.$route.path
                if (path === '/RU') {
                    this.actIdx = 1
                } else if (path === '/Affiliate') {
                    this.actIdx = 3
                } else if (path === '/Event') {
                    this.actIdx = 4
                } else if (path === '/Person') {
                    this.actIdx = 5
                } else {
                    this.actIdx = -1
                }
            },
            deep: true
        }
    },
    methods: {
        change(idx) {
            if (this.actIdx === idx) return
            if (idx !== 2) {
                this.actIdx = idx
            }
            if (idx === 1) {
                this.onNavTo({ url: '/RU', replace: 1 })
            } else if (idx === 2) {
                this.$store.dispatch('user/setIsShowDepositPopup', true)
            } else if (idx === 3) {
                this.onNavTo({ url: '/Affiliate', replace: 1 })
            } else if (idx === 4) {
                this.onNavTo({ url: '/Event', replace: 1 })
            } else if (idx === 5) {
                this.onNavTo({ url: '/Person', replace: 1 })
            }
        },
        onCloseSaveVersion() {
            this.isSaveVersionDesktop = false
        },
        onShowSaveVersionPopup() {
            this.isSaveVersionDesktop = false
            if (getPlatform() === 'ios') {
                this.$refs.pwaIosPopup.open()
            } else {
                this.$refs.SaveVersionPopup.open()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/common/styles/viriables.scss';
// $bg-tabbar-color: $bg-box-color;

.tabbar {
    display: none;
    // max-width: var(--theme-max-width);
}

.tabbar-content {
    display: none;
}

.tabbar-content {
    position: relative;

    .pwa {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: .62rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: rgba($font-title-color, .8);
        padding: 0 .26rem;
        color: $font-theme-color;
        font-size: .34rem;
        z-index: 101;
        line-height: .34rem;
    }
}

.tabbar {
    position: fixed;
    bottom: 0;
    z-index: 100;
    // position: relative;
    margin: 0 auto;
    height: 1.24rem;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--theme-tabbar-shell-bg, #000000);
    border-top: 1px solid var(--theme-tabbar-divider, rgba(255, 255, 255, .12));
    filter: drop-shadow(0 -4px 10px rgba(0, 0, 0, .28));
    // box-shadow: 0rpx -6rpx 13rpx 0rpx rgba(202,255,207,.22);

    .item {
        width: 20%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;
        overflow: visible;
        position: relative;
        cursor: pointer;
        padding-top: 0.08rem;
        padding-bottom: .11rem;

        .tabbar-icon {
            display: block;
            width: .6rem;
            height: .6rem;
            flex: 0 0 .6rem;
            background: var(--theme-tabbar-text, rgba(255, 255, 255, .68));
            -webkit-mask-repeat: no-repeat;
            mask-repeat: no-repeat;
            -webkit-mask-position: center;
            mask-position: center;
            -webkit-mask-size: contain;
            mask-size: contain;

            &.home {
                -webkit-mask-image: url('~@/assets/tabbar/home.png');
                mask-image: url('~@/assets/tabbar/home.png');
            }

            &.recharge {
                -webkit-mask-image: url('~@/assets/tabbar/recharge.png');
                mask-image: url('~@/assets/tabbar/recharge.png');
            }

            &.share {
                -webkit-mask-image: url('~@/assets/tabbar/share.png');
                mask-image: url('~@/assets/tabbar/share.png');
            }

            &.event {
                -webkit-mask-image: url('~@/assets/tabbar/event.png');
                mask-image: url('~@/assets/tabbar/event.png');
            }

            &.person {
                -webkit-mask-image: url('~@/assets/tabbar/person.png');
                mask-image: url('~@/assets/tabbar/person.png');
            }
        }

        .item-text {
            height: .24rem;
            line-height: .24rem;
            width: 100%;
            text-align: center;
            font-size: .22rem;
            color: var(--theme-tabbar-text, rgba(255, 255, 255, .68));
            margin-top: .06rem;
            position: relative;
            z-index: 9;
        }

        &.act {
            background: var(--theme-tabbar-active-bg, transparent);
            background-repeat: no-repeat;
            background-size: var(--theme-tabbar-active-bg-size, 100% 100%);
            background-position: var(--theme-tabbar-active-bg-position, center);

            .tabbar-icon {
                background: var(--theme-tabbar-active-text, #ffffff);
            }

            .item-text {
                color: var(--theme-tabbar-active-text, #ffffff);
            }

            &.center {
                .center-img {
                    .center-inset {
                        border: 1px solid transparent;
                        background: $font-theme-color;
                    }
                }
            }
        }

        &.center {
            position: relative;

            .center-img {
                position: absolute;
                width: 1.2rem;
                height: 1.2rem;
                background: $bg-tabbar-color;
                border-radius: 50%;
                top: -12px;
                display: flex;
                align-items: center;
                justify-content: center;
                left: calc(50% - .6rem);

                .center-inset {
                    border: 1px solid $theme-border-color;
                    border-radius: 50%;
                    width: .95rem;
                    height: .95rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding-bottom: 0;
                    background: $bg-tab-act-color;
                }
            }
        }
    }
}
</style>
